<template>
    <div>
        <div class="form-horizontal" encregion="multipart/form-data" @submit.prevent="store"
             @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                    <th>{{ uLang('app.name') }}</th>
                    <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="websiteTrajectory in websiteTrajectories">
                    <td>
                        <input type="text" v-if="websiteTrajectory.editable" class="form-control"
                               :name="websiteTrajectory.value" v-model="form['value'][websiteTrajectory.id]">
                        <span v-if="!websiteTrajectory.editable">{{ websiteTrajectory.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeWebsiteTrajectory(websiteTrajectory)"
                           class="btn btn-danger" v-if="websiteTrajectory.deleteable"
                           :title="uLang('app.delete_website_trajectory')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newWebsiteTrajectory"
                           :placeholder="uLang('app.new_website_trajectory')"
                           :title="uLang('app.add_new_website_trajectory')">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addWebsiteTrajectory"
                                :disabled="form.busy">{{
                                uLang('app.create_entity', {entity: lang('app.website_trajectory')})
                            }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()"
                       class="btn btn-brand"/>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '~/Form/Form'
import {ErrorAlert, SuccessAlert, DestroyAlert} from '~/Swals'
import {AlphabeticalSort} from '~/mixins'

export default {
    props: {
        settingId: {
            required: true,
        },
    },
    mixins: [
        AlphabeticalSort
    ],
    data() {
        return {
            form: new Form({
                value: {},
            }),
            newWebsiteTrajectory: '',
            websiteTrajectories: []
        }
    },
    mounted: function () {
        this.retrieveValues();
    },
    methods: {
        async store() {
            this.form['patch']('/api/admin/settings/' + this.settingId)
                .then(response => {
                    this.setValues(response);
                    new SuccessAlert({text: this.uLang('app.entity_updated', {entity: lang('app.website_trajectories')})}).show();
                })
                .catch(error => {
                    new ErrorAlert({
                        title: uLang('app.oops_something_went_wrong'),
                        text: uLang('app.all_inputs_need_to_be_filled'),
                    }).show();
                });
        },

        setValues(data) {
            data = this.alphabeticalSort(data)

            this.form.value = {};

            this.websiteTrajectories = data;

            data.forEach(function (websiteTrajectory) {
                if (websiteTrajectory.editable) {
                    this.value[websiteTrajectory.id] = websiteTrajectory.value;
                }

            }, this.form);

        },

        async retrieveValues() {
            // TODO: Check if this basic setting logic happens in other components, and maybe move to mixin
            const {data} = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

            this.setValues(data);
        },

        addWebsiteTrajectory() {
            if (this.newWebsiteTrajectory === '')
                return;


            this.websiteTrajectories.push(
                {
                    id: this.newWebsiteTrajectory,
                    value: this.newWebsiteTrajectory,
                    deleteable: 1,
                    editable: 1
                }
            );
            this.form.value[this.newWebsiteTrajectory] = this.newWebsiteTrajectory;
            this.newWebsiteTrajectory = '';
        },

        removeWebsiteTrajectory(websiteTrajectory) {
            new DestroyAlert({entity: this.lang('app.website_trajectory')}).show().then(async () => {

                delete this.form.value[websiteTrajectory.id];

                //remove the websiteService from the table
                this.websiteTrajectories = this.websiteTrajectories.filter(function (current_website_trajectory) {
                    return current_website_trajectory.value != websiteTrajectory.value;
                });
            })
        }
    }
}
</script>

<style lang="css" scoped>

</style>
